import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import { getLogger } from 'shared/infrastructure/dataDog'
import { App } from './App'

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: () => {
    return new Promise(resolve => {
      resolve(App)
    })
  },
  errorBoundary(err, info, props) {
    getLogger().error(err, { info, props })
    throw err
  },
})

export const { bootstrap, mount, unmount } = lifecycles
